import localSettings from "./preferences";
import { primalLookup } from "./lookup/primal";
import { vertexLookup } from "./lookup/vertex";
import { ProfilePointer } from "nostr-tools/nip19";
import accounts from "./accounts";

export type LookupProvider = "primal" | "vertex";
export type SearchResult = ProfilePointer & { query: string };

/**
 * Lookup users by username using the configured provider
 */
export async function lookupUsers(query: string, limit: number = 10): Promise<SearchResult[]> {
  const provider = localSettings.usernameLookupProvider.value as LookupProvider;

  let results: ProfilePointer[] = [];
  if (!accounts.active) {
    // Use primal for anon users
    results = await primalLookup(query, limit);
  } else {
    switch (provider) {
      case "primal":
        results = await primalLookup(query, limit);
        break;
      case "vertex":
        results = await vertexLookup(query, limit);
        break;
    }
  }

  return results.map((result) => ({ ...result, query }));
}
